import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  readTime: string;
  category: string;
  categoryName: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  image,
  date,
  readTime,
  category,
  categoryName,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 flex flex-col">
      <Link to={`/article/${slug}`} className="block overflow-hidden">
        <div className="relative w-full aspect-[16/10] overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <Link
          to={`/category/${category}`}
          className="inline-flex self-start px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-3 hover:bg-accent-200 transition-colors whitespace-nowrap"
        >
          {categoryName}
        </Link>
        <Link to={`/article/${slug}`} className="group/link">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover/link:text-primary-600 transition-colors duration-200 line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-3 flex-1">
          {excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-500 pt-3 border-t border-background-200/70">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
        </div>
      </div>
    </article>
  );
}